import React, {useEffect, useState} from "react";
import {Checkbox, FormControlLabel} from "@mui/material";

export default function CheckboxInput(props) {
    const [value, setValue] = useState(props.value)

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    const handleChange = (e) => {
        e.persist();
        setValue(e.target.checked)
        if (props.handleChange) {
            // Align with other inputs: handleChange(id/fieldName, value)
            const field = props.fieldName ?? props.id
            props.handleChange(field, e.target.checked)
        }
    }

    return (
        <>
            <FormControlLabel control={<Checkbox title={props.label} checked={value} onChange={handleChange} name={props.fieldName ?? props.id} color='default' inputProps={{ 'aria-label': 'controlled' }} />} label={props.label} />
            <br />
        </>
    )
}